const defaultTouchHandlerProps = touchHandlers(touchCallback)

let touchInProgress = false
let touchStartXPos = 0
function touchHandlers (callback, clickCallback) {
    const handleTouchStart = (e) => {
        touchInProgress = true
		touchStartXPos = getTouchXPosition(e)
    }

    const handleTouchEnd = (e) => {
        e.preventDefault()
        if (touchInProgress) {
            const touchEndXPos = getTouchXPosition(e)
            const diff = touchEndXPos - touchStartXPos
            const felt = Math.abs(diff) > 80

            if (felt) {
                const right = diff > 0
                const left = diff < 0
                callback(left,right)

            } else if (clickCallback) {
                clickCallback(e)
            }

            touchInProgress = false
        }
    }

    return {
        onMouseDown: handleTouchStart,
		onMouseUp: handleTouchEnd,
		onMouseLeave: handleTouchEnd,
		onTouchStart: handleTouchStart,
		onTouchEnd: handleTouchEnd,
    }
}

function getTouchXPosition (e) {
    return e.changedTouches && e.changedTouches.length
		? e.changedTouches[0].clientX
		: e.clientX
}

function touchCallback (left,right) {
    if (left || right) {
        const navItem = document.getElementById(`move-${left?'left':'right'}`)
        if (navItem) navItem.click()
    }
}

export {
    defaultTouchHandlerProps,
    touchHandlers,
    touchCallback,
}